import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { IConBecomeBenefit, IConBecomeCoupon, IConBecomeStar, StyledSquare } from "@components";
import { enumTheme } from "@configs";
import { ModuleMemberShipTier } from "@modules";
import { selectApp, selectAuth, selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { useEffect, useState } from "react";

export const ComponentUserDetail = () => {
    //hooks
    const { t } = useTranslation();
    //redux page
    const { name, themes, welcomeImageUrls } = useSelector(selectMerchant);
    const { userInfo } = useSelector(selectAuth);
    const { langSetting } = useSelector(selectApp);
    // const { themeMode } = useSelector(selectMerchant);
    const themeMode = themes?.themeMode || "light";
    const merchant = useSelector(selectMerchant);
    //page variable
    const memberTier = userInfo?.memberTier;

    const bg_color = themeMode === enumTheme.DARK ? "#f1f1f1" : "#000000";
    const [currentTier, setCurrentTier] = useState<any>();
    useEffect(() => {
        let tierList = merchant?.memberShipTiers;
        let thisTier = tierList?.find(
            (x: any) => x.membershipName === userInfo?.memberTier?.tierName
        );
        setCurrentTier(thisTier);
    }, []);

    return (
        <>
            <RenderMeta title={t("meta.membership_detail")} />
            <StyledUserDetail>
                <div className="righttoleft">
                    <StyledCart>
                        <div className="become text-sub-header">{t("page.become_member")}</div>
                        <div className="desc body-text">
                            {t("page.fill_in_your_information")}
                            {name} {t("page._and_receive")}
                        </div>
                        <div className="group text-body">
                            <div className="item">
                                <div className="svg">
                                    <IConBecomeStar
                                        bg_color={bg_color}
                                        color={themes?.themeColor!}
                                    />
                                </div>
                                <span>{t("page.star_desc")}</span>
                            </div>
                            <div className="item">
                                <div className="svg">
                                    <IConBecomeCoupon
                                        bg_color={bg_color}
                                        color={themes?.themeColor!}
                                    />
                                </div>
                                <span>{t("page.coupon_desc")}</span>
                            </div>
                            <div className="item">
                                <div className="svg">
                                    <IConBecomeBenefit
                                        bg_color={bg_color}
                                        color={themes?.themeColor!}
                                    />
                                </div>
                                <span>{t("page.benefit_desc")}</span>
                            </div>
                            <div className="item border-none">
                                <div className="svg">
                                    <IConBecomeStar
                                        bg_color={bg_color}
                                        color={themes?.themeColor!}
                                    />
                                </div>
                                <span>{t("page.draws_desc")}</span>
                            </div>
                        </div>
                    </StyledCart>
                </div>
                <div className="righttoleft2s">
                    <StyledCart>
                        <div className="text-content">
                            <div className="title_rule text-sub-header">
                                {t("page.rules_of_points")}
                            </div>
                            <div className="points">
                                <div className="left text-sec-sub-header">
                                    <StyledButtonPoint
                                        themeColor={themes?.themeColor!}
                                        className="text-sec-sub-header eng-number"
                                    >
                                        {memberTier?.bahtSpent || 0}
                                    </StyledButtonPoint>
                                </div>
                                <div className="equal">=</div>
                                <div className="right">
                                    <StyledButtonPoint
                                        themeColor={themes?.themeColor!}
                                        className="text-sec-sub-header eng-number"
                                    >
                                        {memberTier?.points || 0}
                                    </StyledButtonPoint>
                                </div>
                            </div>
                            <div className="points">
                                <div className="baht_spent text-body">
                                    {t("page.baht")}
                                </div>
                                <div className="baht_spent text-body">{t("page._points")}!</div>
                            </div>
                        </div>
                    </StyledCart>
                </div>

                <div className="righttoleft3s">
                    <ModuleMemberShipTier
                        maintainPoint={userInfo?.pointEarnRemainToMaintain || 0}
                        firstTier={false}
                        percent={userInfo?.percentToMaintain || 0}
                        date={userInfo?.maintainDate || ""}
                        tierColor={currentTier?.color || "white"}
                        tierIcon={currentTier?.icon || "star"}
                        isBalance={merchant?.superAdminTier?.isPointBalance}
                    />
                </div>
                <div className="group_image">
                    {welcomeImageUrls?.map((welcomeImageUrl, wIndex) => {
                        return (
                            <StyledSquare key={wIndex}>
                                <div className="content">
                                    <img className="image" src={welcomeImageUrl} />
                                </div>
                            </StyledSquare>
                        );
                    })}
                </div>
            </StyledUserDetail>
        </>
    );
};

const StyledCart = styled.div`
    width: calc(100% - 30px);
    margin: 0 auto;
    padding: 0 24px 20px 24px;
    background-color: ${(p) => p.theme.colors.card};
    box-shadow: rgb(215 215 215) 0px 0px 4px 0px;
    border-radius: 12px;
    margin-bottom: 20px;
    .become {
        text-align: center;
        padding-top: 30px;
        font-style: normal;
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 24px;
    }
    .desc {
        text-align: center;
        color: ${(p) => p.theme.colors.color};
        line-height: 1.5rem;
        font-style: normal;
        margin-bottom: 6px;
    }
    .group {
        .item {
            padding: 14px 0;
            border-bottom: 1px solid rgba(115, 115, 115, 0.31);
            display: flex;
            align-items: end;
            .svg {
                text-align: center;
                width: 28px;
            }
            span {
                display: inline-block;
                margin-left: 20px;
                font-style: normal;
                color: ${(p) => p.theme.colors.color};
            }
        }
    }
    .border-none {
        border-bottom: initial !important;
    }
    .title_rule {
        font-style: normal;
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 32px;
    }
    .text-content {
        text-align: center;
        padding: 44px 0;
        .points {
            width: calc(80%);
            margin: 0 auto;
            display: flex;
            justify-content: space-around;
            align-items: center;
            .left,
            .right {
                flex: 1;
                text-align: center;
                margin-bottom: 6px;
            }

            .baht_spent {
                font-size: 16px;
                color: ${(p) => p.theme.colors.color};
                text-align: center;
                display: inline-block;
                position: relative;
                left: 0px;
                color: inherit;
            }
        }
    }
`;

const StyledButtonPoint = styled.div<{ themeColor: string }>`
    width: fit-content;
    padding: 6px 24px;
    background: ${(p) => p.theme.colors.card};
    color: ${(p) => p.themeColor};
    border-radius: 4px;
    margin-bottom: 6px;
    margin: 0 auto;
`;

const StyledUserDetail = styled.div`
    background: transparent;
    padding-bottom: 50px;
    z-index: 1;
    position: relative;
    .group_image {
        text-align: center;
    }
`;
